if (!customElements.get('faq-accordion')) {
  customElements.define(
    'faq-accordion',
    class FaqAccordion extends HTMLElement {
      connectedCallback() {
        this.allowMultiple = this.hasAttribute('data-multiple');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.querySelectorAll('details').forEach((item) => {
          item.querySelector('summary').addEventListener('click', (event) => {
            event.preventDefault();
            if (item.open) {
              this.close(item);
            } else {
              this.open(item);
            }
          });
        });
      }

      open(item) {
        if (!this.allowMultiple) {
          this.querySelectorAll('details[open]').forEach((other) => {
            if (other !== item) this.close(other);
          });
        }

        item.open = true;
        const panel = item.querySelector('.faq-accordion__panel');
        if (this.reducedMotion || !panel.animate) return;
        panel.getAnimations().forEach((running) => running.cancel());

        panel.animate(
          [
            { height: '0px', opacity: 0 },
            { height: `${panel.scrollHeight}px`, opacity: 1 },
          ],
          { duration: 280, easing: 'cubic-bezier(0.32, 0.72, 0, 1)' }
        );
      }

      close(item) {
        const panel = item.querySelector('.faq-accordion__panel');
        if (this.reducedMotion || !panel.animate) {
          item.open = false;
          return;
        }

        const startHeight = panel.offsetHeight;
        panel.getAnimations().forEach((running) => running.cancel());
        const animation = panel.animate(
          [
            { height: `${startHeight}px`, opacity: 1 },
            { height: '0px', opacity: 0 },
          ],
          { duration: 220, easing: 'ease-out', fill: 'forwards' }
        );
        animation.onfinish = () => {
          item.open = false;
          animation.cancel();
        };
      }
    }
  );
}
